export const TKeyMarketAnalysis = {
  MARKET_ANALYSIS_NAV: "MARKET_ANALYSIS_NAV",
} as const;
